// Названия замороженных кодов подотчёта и формы множественного числа.
//
// Коды приходят с сервера латиницей (`contracts/enums/statuses.yaml`), а человеку нужны
// слова. Держим их здесь, а не в разметке: одно и то же состояние показывается в списке, в
// карточке и в панели, и три разных перевода одного кода — это три разных экрана.

import type { CashMethod, ClaimStatus, TransferStatus } from '@/shared/api/endpoints/accountable';
import type { PluralForms } from '@/shared/text/plural';

/** Уровень подотчётного лица. Словами, а не «primary»: их читает старший объекта. */
export const LEVEL_TITLES: Record<string, string> = {
  primary: 'от кассы',
  field: 'в поле',
};

export const METHOD_TITLES: Record<CashMethod, string> = {
  cash: 'наличными',
  transfer: 'переводом',
};

export const CLAIM_STATUS_TITLES: Record<ClaimStatus, string> = {
  draft: 'Черновик',
  submitted: 'Подана',
  accepted: 'Принята',
  rejected: 'Отклонена',
  returned: 'Возвращена',
  reversed: 'Сторнирована',
};

/**
 * Вид метки состояния. Цвет ДУБЛИРУЕТ слово, а не заменяет его: на пересвеченном экране и
 * при дальтонизме остаётся только текст.
 */
export const CLAIM_STATUS_TONE: Record<ClaimStatus, 'gray' | 'blue' | 'green' | 'red' | 'orange'> =
  {
    draft: 'gray',
    submitted: 'blue',
    accepted: 'green',
    rejected: 'red',
    returned: 'orange',
    reversed: 'gray',
  };

export const TRANSFER_STATUS_TITLES: Record<TransferStatus, string> = {
  pending: 'В пути',
  accepted: 'Подтверждена',
  declined: 'Отклонена',
  reversed: 'Сторнирована',
};

export const PERSON_FORMS: PluralForms = [
  'подотчётное лицо',
  'подотчётных лица',
  'подотчётных лиц',
];

export const CLAIM_FORMS: PluralForms = ['заявка', 'заявки', 'заявок'];

export const DAY_FORMS: PluralForms = ['день', 'дня', 'дней'];
